import { ReactComponent as Logout } from "assets/img/icons/logoutBtn.svg";
import React, { useEffect, useRef, useState } from "react";
import { FaCheck } from "react-icons/fa";
import Modal from "react-modal";
import { useAccount, useDisconnect } from "wagmi";
import Button from "../button/button";

import { shortAddress } from "app/utils/shortAddress";
import styles from "./dashboard-modal.module.scss";

interface IDashboardModal {
  isOpen: boolean;
  redirectToAlphamind: () => void;
  closeModal: () => void;
}

enum EDashboard {
  HIDDEN = "hidden",
  AUTO = "auto",
}

const DashboardModal: React.FC<IDashboardModal> = ({
  isOpen,
  redirectToAlphamind,
  closeModal,
}) => {
  const { disconnect } = useDisconnect();
  const { address } = useAccount();
  const [copied, setCopied] = useState<boolean>(false);
  const timeoutRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = EDashboard.HIDDEN;
    } else {
      document.body.style.overflow = EDashboard.AUTO;
    }

    return () => {
      document.body.style.overflow = EDashboard.AUTO;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isOpen]);

  const handleDisconnect = () => {
    disconnect();
    window.claimr?.logout();
    closeModal();
  };

  const handleCopyAddress = () => {
    if (address) {
      navigator.clipboard
        .writeText(address)
        .then(() => {
          setCopied(true);
          timeoutRef.current = window.setTimeout(() => setCopied(false), 3000);
        })
        .catch((err) => {
          console.error("Failed to copy address: ", err);
        });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Mint NFT Modal"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      className={styles.modalContent}
      overlayClassName={styles.modalOverlay}
    >
      <h2>
        To enter the dashboard & access our Alpha, you need to have Unicorn NFT
        which is your user pass. Go Home page, complete onboarding quest, get
        your Karma and mint a Unicorn for free.
      </h2>
      <Button className={styles.address} onClick={handleCopyAddress}>
        {copied ? (
          <>
            Copied &nbsp;
            <FaCheck />
          </>
        ) : (
          <>
            Your wallet:&nbsp;
            {shortAddress(address)}
          </>
        )}
      </Button>
      <div className={styles.btnWrapper}>
        <Button onClick={redirectToAlphamind}>Go to AlphaMind.co</Button>
        <Button className={styles.logoutBtn} onClick={handleDisconnect}>
          <Logout />
        </Button>
      </div>
    </Modal>
  );
};

export default DashboardModal;
